module.exports = __webpack_public_path__ + "img/4steps.66ea1b62.svg";